/* unplugin-vue-components disabled */import { render } from "./DashboardTabs.vue?vue&type=template&id=6a963d83&scoped=true"
import script from "./DashboardTabs.vue?vue&type=script&lang=js"
export * from "./DashboardTabs.vue?vue&type=script&lang=js"

import "./DashboardTabs.vue?vue&type=style&index=0&id=6a963d83&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a963d83"]])

export default __exports__